import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697a3827921dc90014ee7b36/sig_day_global/src/app/research-evidence/components/ResearchInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697a3827921dc90014ee7b36/sig_day_global/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697a3827921dc90014ee7b36/sig_day_global/src/components/ui/AppIcon.tsx");
